module.exports = require("./lib/_stream_writable.js")



/*****************
 ** WEBPACK FOOTER
 ** (webpack)/~/stream-browserify/~/readable-stream/writable.js
 ** module id = 4202
 ** module chunks = 0
 **/